import qs from 'query-string';
import { apiConfig } from '@/services/api-config';

// eslint-disable-next-line no-shadow
export enum TerritoryStatus {
  provisional = 'PROVISORIO',
  inactive = 'INATIVO',
  none = 'NONE'
}

export default async function (document: string, name = '', status = TerritoryStatus.none, isFrig = false) {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);

  const { idUser } = userLogged;
  const { stKey } = userLogged.company;

  const query = qs.stringify({
    document,
    tokenKey: stKey,
    isFrig,
    name,
    frigId: idUser,
    status,
  });

  return apiConfig
    .get(`api/territory/get-by-agent-document?${query}`)
    .then((response) => {
      const { objectResult } = response.data;

      return objectResult;
    })
    .catch(() => []);
}
